import React from 'react';
import { Bot } from 'lucide-react';

interface AppBadgeProps {
  className?: string;
}

const AppBadge: React.FC<AppBadgeProps> = ({ className = '' }) => (
  <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-blue-400/15 text-blue-300 border border-blue-400/30 select-none ${className}`}>
    <Bot className="h-3 w-3" />
    APP
  </span>
);

export default AppBadge;
